import {
  FETCH_CREATORS_START, FETCH_CREATORS_SUCCESS, FETCH_CREATORS_ERROR,
  FETCH_CREATOR_DETAIL_START, FETCH_CREATOR_DETAIL_SUCCESS, FETCH_CREATOR_DETAIL_ERROR,
  FETCH_AGENCIES_START, FETCH_AGENCIES_SUCCESS, FETCH_AGENCIES_ERROR,
  FETCH_AGENCY_DETAIL_START, FETCH_AGENCY_DETAIL_SUCCESS, FETCH_AGENCY_DETAIL_ERROR,
  FETCH_BRAND_DETAIL_START, FETCH_BRAND_DETAIL_SUCCESS, FETCH_BRAND_DETAIL_ERROR,
  FETCH_MY_ANALYTICS_START, FETCH_MY_ANALYTICS_SUCCESS, FETCH_MY_ANALYTICS_ERROR,
  FETCH_SAVED_PROFILES_START, FETCH_SAVED_PROFILES_SUCCESS, FETCH_SAVED_PROFILES_ERROR,
  FETCH_SHORTLISTS_START, FETCH_SHORTLISTS_SUCCESS, FETCH_SHORTLISTS_ERROR,
} from '../../Action/actionTypes'

const initialState = {
  creators: [],
  creatorsMeta: null,
  creatorsLoading: false,
  creatorsLoadingMore: false,
  creatorsError: null,

  creatorDetail: null,
  creatorDetailLoading: false,
  creatorDetailError: null,

  agencies: [],
  agenciesMeta: null,
  agenciesLoading: false,
  agenciesLoadingMore: false,
  agenciesError: null,

  agencyDetail: null,
  agencyDetailLoading: false,
  agencyDetailError: null,

  brandDetail: null,
  brandDetailLoading: false,
  brandDetailError: null,

  myAnalytics: [],
  myAnalyticsLoading: false,
  myAnalyticsError: null,

  savedCreators: [],
  savedAgencies: [],
  savedLoading: false,
  savedError: null,

  shortlists: [],
  shortlistsLoading: false,
  shortlistsError: null,
}

const discoveryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CREATORS_START:
      return action.payload?.append
        ? { ...state, creatorsLoadingMore: true, creatorsError: null }
        : { ...state, creatorsLoading: true, creatorsError: null }
    case FETCH_CREATORS_SUCCESS:
      return {
        ...state,
        creatorsLoading: false,
        creatorsLoadingMore: false,
        creators: action.payload.append
          ? [...state.creators, ...(action.payload.creators ?? [])]
          : (action.payload.creators ?? []),
        creatorsMeta: action.payload.meta ?? null,
      }
    case FETCH_CREATORS_ERROR:
      return { ...state, creatorsLoading: false, creatorsLoadingMore: false, creatorsError: action.payload }

    case FETCH_CREATOR_DETAIL_START:
      return { ...state, creatorDetailLoading: true, creatorDetailError: null }
    case FETCH_CREATOR_DETAIL_SUCCESS:
      return { ...state, creatorDetailLoading: false, creatorDetail: action.payload.creator ?? action.payload }
    case FETCH_CREATOR_DETAIL_ERROR:
      return { ...state, creatorDetailLoading: false, creatorDetailError: action.payload }

    case FETCH_AGENCIES_START:
      return action.payload?.append
        ? { ...state, agenciesLoadingMore: true, agenciesError: null }
        : { ...state, agenciesLoading: true, agenciesError: null }
    case FETCH_AGENCIES_SUCCESS:
      return {
        ...state,
        agenciesLoading: false,
        agenciesLoadingMore: false,
        agencies: action.payload.append
          ? [...state.agencies, ...(action.payload.agencies ?? [])]
          : (action.payload.agencies ?? []),
        agenciesMeta: action.payload.meta ?? null,
      }
    case FETCH_AGENCIES_ERROR:
      return { ...state, agenciesLoading: false, agenciesLoadingMore: false, agenciesError: action.payload }

    case FETCH_AGENCY_DETAIL_START:
      return { ...state, agencyDetailLoading: true, agencyDetailError: null }
    case FETCH_AGENCY_DETAIL_SUCCESS:
      return { ...state, agencyDetailLoading: false, agencyDetail: action.payload.agency ?? action.payload }
    case FETCH_AGENCY_DETAIL_ERROR:
      return { ...state, agencyDetailLoading: false, agencyDetailError: action.payload }

    case FETCH_BRAND_DETAIL_START:
      return { ...state, brandDetailLoading: true, brandDetailError: null }
    case FETCH_BRAND_DETAIL_SUCCESS:
      return { ...state, brandDetailLoading: false, brandDetail: action.payload.brand ?? action.payload }
    case FETCH_BRAND_DETAIL_ERROR:
      return { ...state, brandDetailLoading: false, brandDetailError: action.payload }

    case FETCH_MY_ANALYTICS_START:
      return { ...state, myAnalyticsLoading: true, myAnalyticsError: null }
    case FETCH_MY_ANALYTICS_SUCCESS:
      return { ...state, myAnalyticsLoading: false, myAnalytics: action.payload.analytics ?? [] }
    case FETCH_MY_ANALYTICS_ERROR:
      return { ...state, myAnalyticsLoading: false, myAnalyticsError: action.payload }

    case FETCH_SAVED_PROFILES_START:
      return { ...state, savedLoading: true, savedError: null }
    case FETCH_SAVED_PROFILES_SUCCESS:
      return {
        ...state,
        savedLoading: false,
        savedCreators: action.payload.saved_creators ?? [],
        savedAgencies: action.payload.saved_agencies ?? [],
      }
    case FETCH_SAVED_PROFILES_ERROR:
      return { ...state, savedLoading: false, savedError: action.payload }

    case FETCH_SHORTLISTS_START:
      return { ...state, shortlistsLoading: true, shortlistsError: null }
    case FETCH_SHORTLISTS_SUCCESS:
      return { ...state, shortlistsLoading: false, shortlists: action.payload ?? [] }
    case FETCH_SHORTLISTS_ERROR:
      return { ...state, shortlistsLoading: false, shortlistsError: action.payload }

    default:
      return state
  }
}

export default discoveryReducer
